// extracted by mini-css-extract-plugin
module.exports = {"card":"LoginCard_card__2SX__","form":"LoginCard_form__15dOM"};